import { HttpClient } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { catchError, map, Observable, of } from 'rxjs';

/**
 * Servicio simplificado para cargar traducciones dinámicas
 * Se enfoca únicamente en la carga de traducciones, sin manejar el Store
 * El Store se maneja por separado en TranslationStoreManagerService
 */
@Injectable({
  providedIn: 'root'
})
export class DynamicTranslateLoaderService implements TranslateLoader {

 private injector = inject(Injector);

  constructor(private http: HttpClient) { 
  }  

  private get messageService(): MessageService | undefined {
    try {
      return this.injector.get(MessageService, null);
    } catch {
      return undefined;
    }
  }
  
  getTranslation(lang: string): Observable<any> {
    const languageTemplateUrl = localStorage.getItem('languageTemplateUrl');

    if (languageTemplateUrl) {

      const cacheBuster = `?v=${new Date().getTime()}`;
      return this.http.get(languageTemplateUrl + cacheBuster).pipe(
        map((response: any) => {
          if (response && response) {
            return response;
          } else {
            console.warn('⚠️ DynamicTranslateLoaderService: No storeFront section found in blob storage response');
            this.messageService.add({ severity: 'warn', summary: 'Notificación', detail: 'No se encontro sección storeFront en la respuesta del almacenamiento de blobs' });
            return {};
          }
        }),
        catchError((error: any) => {
          this.messageService.add({ severity: 'warn', summary: 'Notificación', detail: 'No se encontro plantilla de Idioma configurada en el almacenamiento del blobs' });
          return this.http.get(`/assets/i18n/${lang}.json`).pipe(
            catchError((localError) => {
              console.error('❌ DynamicTranslateLoaderService: Error loading local translations:', localError);
              this.messageService.add({ severity: 'warn', summary: 'Notificación', detail: 'No se encontro plantilla de Idioma configurada Localmente.' });
              return of({}); // Retorna objeto vacío en caso de error total
            })
          );
        })
      );
    } else {
      this.messageService?.add({ severity: 'warn', summary: 'Notificación', detail: 'No se encontro plantilla de Idioma configurada Localmente.' });
      // No hay URL de blob storage, usar traducciones locales
      return this.http.get(`/assets/i18n/${lang}.json`).pipe(
        map((localResponse: any) => {
          return localResponse;
        }),
        catchError((error) => {
          return of({}); // Retorna objeto vacío en caso de error
        })
      );
    }
  }  /**
   * Método para actualizar la URL del template de idioma
   * Nota: Para recargar traducciones usar TranslationStoreManagerService.updateLanguageTemplate()
   */
  // updateLanguageTemplateUrl(url: string): void {
  //   console.log('🔄 DynamicTranslateLoaderService: Updating languageTemplateUrl in localStorage:', url);
  //   localStorage.setItem('languageTemplateUrl', url);
  // }

  /**
   * Método para limpiar la URL del template
   * Nota: Para recargar traducciones usar TranslationStoreManagerService.clearLanguageTemplate()
   */
  clearLanguageTemplateUrl(): void {
    console.log('🧹 DynamicTranslateLoaderService: Clearing languageTemplateUrl from localStorage');
    localStorage.removeItem('languageTemplateUrl');
  }
}

